import * as React from "react";
const SvgArrowRight = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "24px", viewBox: "0 -960 960 960", width: "24px", fill: "var(--Schemes-On-Surface)", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M400-280v-400l200 200-200 200Z" }));
export default SvgArrowRight;
